import { TProcessingResult } from '@ws/shared/types';

import { ResultFormatter } from './ResultFormatter';

export abstract class Processor<T> extends ResultFormatter<T> {
  public process(value: T): TProcessingResult<T> {
    return this.createSuccessResponse(value);
  }
}
